<span class="email-icon mr-2"
	  *ngIf="email"
	  [matTooltip]="isOpened ? '' : 'We have a work email address for this contact'" matTooltipPosition="after">
</span>
<span class="personal-email-icon mr-2" *ngIf="personalEmail"
	  [matTooltip]="isOpened ? '' : 'We have a personal email address for this contact'" matTooltipPosition="after">
</span>
<span class="phone-icon mr-2" [ngClass]="phoneType"
	  *ngIf="(phoneNumbers | bestPhoneType: 'work_mobile') as phoneType"
	  [matTooltip]="isOpened ? '' : 'We have a work mobile number for this contact'" matTooltipPosition="after">
</span>
<span class="phone-icon mr-2" [ngClass]="phoneType"
	  *ngIf="(phoneNumbers | bestPhoneType: 'mobile') as phoneType"
	  [matTooltip]="isOpened ? '' : 'We have a mobile number for this contact'" matTooltipPosition="after">
</span>
<span class="phone-icon mr-2" [ngClass]="phoneType"
	  *ngIf="(phoneNumbers | bestPhoneType: 'work') as phoneType"
	  [matTooltip]="isOpened ? '' : 'We have a work phone number for this contact'" matTooltipPosition="after">
</span>
<span class="phone-icon mr-2" [ngClass]="phoneType"
	  *ngIf="(phoneNumbers | bestPhoneType: 'work_dbn') as phoneType"
	  [matTooltip]="isOpened ? '' : 'We have a dial by name phone number for this contact'" matTooltipPosition="after">
</span>
<span class="phone-icon mr-2" [ngClass]="phoneType"
	  *ngIf="(phoneNumbers | bestPhoneType: 'work_hq') as phoneType"
	  [matTooltip]="isOpened ? '' : 'We have a head quarter phone number for this contact'" matTooltipPosition="after">
</span>
<span class="phone-icon mr-2" [ngClass]="phoneType"
	  *ngIf="(phoneNumbers | bestPhoneType: 'work_branch') as phoneType"
	  [matTooltip]="isOpened ? '' : 'We have a branch phone number for this contact'" matTooltipPosition="after">
</span>
<a class="linkedin-icon mr-2" target="_blank"
   *ngIf="socialProfiles?.length"
   [matTooltip]="isOpened ? '' : 'Click to open the LinkedIn profile of this contact'"
   matTooltipPosition="after"
   [attr.href]="socialProfiles[0].url | formatUrl"
   (click)="commonUtilService.onFocusTooltip($event)">
</a>
<a class="www-icon mr-2" *ngIf="primaryDomain" href="http://{{primaryDomain}}"
   [matTooltip]="primaryDomain" matTooltipPosition="after" target="_blank"
   (click)="commonUtilService.onFocusTooltip($event)">
</a>
<span class="pr-2"
	  *ngIf="purchaseHistory | purchaseHistory"
	  [matTooltip]="isOpened ? '' : 'This contact is already revealed or exported by you or one of your team members'" matTooltipPosition="after">
	<span class="inline-flex items-center justify-center w-5 h-[15px] align-middle text-primary-light">
		<fa-icon aria-hidden="true" class="si-icon relative -left-px text-[15px]" [icon]="['fas', 'eye']"></fa-icon>
	</span>
</span>
